import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import config from '../../../config';

import LoadImage from '../../components/LoadImage';


class ViewLarge extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    t: PropTypes.func,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    picture: PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      data: PropTypes.shape({
        html: PropTypes.node,
      }),
    }),
    type: PropTypes.oneOf(['picture', 'video']),
    src: PropTypes.string,
    onSlide: PropTypes.func,
    disabledLeft: PropTypes.bool,
    disabledRight: PropTypes.bool,
    slideshow: PropTypes.bool,
    pictureSize: PropTypes.number,
    extension: PropTypes.string,
  }
  static defaultProps = {
    pictureSize: 100,
    type: 'picture',
  }
  shouldComponentUpdate(nextProps) {
    if (
      (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture)) ||
      (this.props.type !== nextProps.type) ||
      (this.props.src !== nextProps.src) ||
      (this.props.open !== nextProps.open)
    ) {
      return true;
    }
    return false;
  }
  hasTouch = () => 'ontouchstart' in document.documentElement
    || navigator.maxTouchPoints > 0
    || navigator.msMaxTouchPoints > 0;
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnSlide = (e, direction) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.onSlide) {
      this.props.onSlide(e, direction);
    }
  }
  renderLabel = () => {
    const { picture } = this.props;
    if (picture && picture.label) {
      return (
        <Modal.Actions>
          <p>{picture.label}</p>
        </Modal.Actions>
      );
    }
    return null;
  }
  renderContent = () => {
    const { picture, type } = this.props;
    if (type === 'video' && picture && picture.data) {
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
          dangerouslySetInnerHTML={{
            __html: picture.data.html,
          }}
        />
      );
    }
    return (
      <LoadImage
        centered
        picture={picture}
        pictureSize={this.props.pictureSize}
        src={this.props.src}
        openNewTab
        showLabel
        extension={this.props.extension}
        bucketName={config.get('mpBucket')}
        labelNode={
          this.props.slideshow && (
            <div>
              <Button
                className={`slide-show-button ${this.hasTouch() ? '' : 'no-touch'}`}
                inverted
                floated="left"
                size="massive"
                onClick={e => this.handleOnSlide(e, 'left')}
                icon="chevron left"
                disabled={this.props.disabledLeft}
              />
              <Button
                className={`slide-show-button ${this.hasTouch() ? '' : 'no-touch'}`}
                inverted
                floated="right"
                size="massive"
                onClick={e => this.handleOnSlide(e, 'right')}
                icon="chevron right"
                disabled={this.props.disabledRight}
              />
            </div>
          )
        }
      />
    );
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        basic
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        className="view-large"
      >
        <Header content={t('Preview')} />
        <Modal.Content image className="slideshow">
          {this.renderContent()}
        </Modal.Content>
        {this.renderLabel()}
      </Modal>
    );
  }
}

export default withTranslation()(ViewLarge);



// WEBPACK FOOTER //
// ./src/containers/modals/ViewLarge.jsx